interface AWSConfig {
  aws_project_region: string;
  aws_cognito_region: string;
  aws_user_pools_id: string;
  aws_user_pools_web_client_id: string;
  authenticationFlowType: string;
  oauth: {
    domain: string;
    scope: string[];
    redirectSignIn: string;
    redirectSignOut: string;
    responseType: string;
  };
}

const awsconfig: AWSConfig = {
  aws_project_region: "eu-west-3",
  aws_cognito_region: "eu-west-3",
  aws_user_pools_id:
    process.env.REACT_APP_USER_POOLS_ID || "eu-west-3_gatxf1xJ5",
  aws_user_pools_web_client_id:
    process.env.REACT_APP_USER_POOLS_WEB_CLIENT_ID ||
    "6acm9g1vsf4mpsjthnficr0hvd",
  authenticationFlowType: "USER_SRP_AUTH",
  oauth: {
    domain:
      process.env.REACT_APP_OAUTH_DOMAIN ||
      "shiplify_pro.auth.eu-west-3.amazoncognito.com",
    scope: ["email", "openid", "profile"],
    redirectSignIn:
      process.env.REACT_APP_REDIRECT_SIGN_IN ||
      "https://pro.shiplify.io/signin",
    redirectSignOut:
      process.env.REACT_APP_REDIRECT_SIGN_OUT ||
      "https://pro.shiplify.io/signin",
    responseType: "code",
  },
};

export default awsconfig;
